<template>
  <div class="container input-tooltip-container">
    <div class="input-tooltip--mask" v-if="show" />
    <div class="input-tooltip-container__inner-component">
      <slot />
    </div>
    <div
      v-if="description"
      class="input-tooltip-container__description-container"
      @click="toggleTooltip"
      @mouseenter="showTooltip"
      @mouseleave="hideTooltip"
    >
      <img src="@/assets/img/1x/0info_icon.svg" alt="info" />
      <div v-if="show" class="input-tooltip-container__description">
        <div class="close-container">
          <img src="@/assets/img/1x/close.svg" alt="cerrar" />
        </div>
        <span v-html="description" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputTooltip",
  props: {
    description: String
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    toggleTooltip() {
      this.show = !this.show;
    },
    hideTooltip() {
      if (window.innerWidth > 615) {
        this.show = false;
      }
    },
    showTooltip() {
      if (window.innerWidth > 615) {
        this.show = true;
      }
    }
  }
};
</script>

<style scoped>
.input-tooltip-container {
  display: flex;
  align-items: center;
  margin-right: -36px;
  cursor: pointer;
}
.input-tooltip-container__inner-component {
  flex: 1;
}
.input-tooltip-container__description-container {
  position: relative;
  width: 36px;
  text-align: right;
  line-height: 0;
}
.input-tooltip-container__description-container img {
  display: inline-block;
  margin: 0;
  border: 0;
  width: 20px;
  height: 20px;
}
.input-tooltip-container__description {
  position: absolute;
  left: 54px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #1973b8;
  padding: 8px 12px;
  width: 220px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #ffffff;
  white-space: normal;
  text-align: left;
}
.input-tooltip-container__description:before {
  content: "";
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 8px 8px 0;
  border-color: transparent #1973b8 transparent transparent;
}

.close-container {
  display: none;
}

.close-container img {
  width: 16px;
  height: 16px;
}

@media screen and (max-width: 840px) {
  .input-tooltip-container {
    display: flex;
    align-items: center;
    margin-right: -36px;
  }
  .input-tooltip-container__description {
    right: 35px;
    left: auto;
  }
  .input-tooltip-container__description:before {
    left: auto;
    right: -8px;
    border-width: 8px 0 8px 8px;
    border-color: transparent transparent transparent #1973b8;
  }
}

@media screen and (max-width: 615px) {
  .close-container {
    display: block;
    position: absolute;
    right: 18px;
    top: 18px;
  }
  .input-tooltip--mask {
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
    justify-content: center;
  }
  .input-tooltip-container {
    margin-right: 0;
  }
  .input-tooltip-container__description {
    position: fixed;
    z-index: 100000;
    max-width: none;
    width: auto;
    left: 17px;
    right: 17px;
    padding: 56px 18px;
    top: 50%;
    transform: translateY(-50%);
    color: #000;
    background-color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  }
  .input-tooltip-container__description:before {
    content: none;
  }
}
</style>
